import { useEffect, useRef } from "react";

// Staff has no live payment socket, so this keeps the Admin hook's shape but
// only polls: while a bookingId is set, onResync runs every POLL_MS so a
// payment made through a link shows up without a manual refresh.
const POLL_MS = 6000;

export default function usePaymentEvents({ bookingId, poll = false, onResync } = {}) {
    const resyncRef = useRef(onResync);
    resyncRef.current = onResync;

    useEffect(() => {
        if (!bookingId && !poll) return undefined;
        const timer = setInterval(() => resyncRef.current && resyncRef.current(), POLL_MS);
        return () => clearInterval(timer);
    }, [bookingId, poll]);

    return { connected: false };
}
